'use strict';

import { view } from '@/functions';

const prefix = '/activitys';
export default [
    {
        path: prefix,
        name: 'activity',
        meta: {
            title: 'Activity',
            scopes: ['read_activity', 'write_activity']
        },
        component: () => view('activitys/index'),
    },
    {
        path: `${prefix}/info`,
        name: 'activity-info',
        meta: {
            title: 'Activity',
            scopes: ['read_activity', 'write_activity'],
            workspace: true,
        },
        component: () => view('activitys/infov2'),
    },
    {
        path: `${prefix}/v1`,
        name: 'activity-info-v1',
        meta: {
            title: 'Activity',
            scopes: ['read_activity', 'write_activity'],
        },
        component: () => view('activitys/info'),
    },
];
